export const formatGameTimeET = (gameTime: string) => {
  const date = new Date(gameTime);
  const day = date.toLocaleDateString([], { month: 'short', day: '2-digit', timeZone: 'America/New_York' });
  const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZone: 'America/New_York' });
  return `${day} @ ${time} ET`;
};
